<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('book.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('book.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('book.detail.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row" v-if="book_cover">
      <div class="col">
        <b-img :src="book_cover.url" fluid center></b-img>
      </div>
    </div>
    <div class="row">
      <div class="col"><hr></div>
    </div>
    <div class="row">
      <div class="col">
        <book-info :book="book"></book-info>
        <b-button-toolbar>
          <b-button-group>
            <b-button variant="outline-default" @click="showSizeCmConversionTableModal">{{ $t('book.button.size-cm-conversion.label') }}</b-button>
            <b-button
              variant="primary"
              @click="addBookToApplicationList(book)"
              :disabled="book.in_stock == 'N'"
            >{{ book.in_stock == 'N' ? $t('book.button.application.label.out-of-stock') : $t('book.button.application.label.in-stock') }}</b-button>
          </b-button-group>
        </b-button-toolbar>
        <dharma-application-form ref="application_form"></dharma-application-form>
        <size-cm-conversion-table-modal id="size-cm-conversion-table-modal"></size-cm-conversion-table-modal>
        <dharma-grant-susp-msg-modal id="dharma-grant-susp-msg-modal"></dharma-grant-susp-msg-modal>
      </div>
    </div>
    <div class="row">
      <div class="col"><hr></div>
    </div>
    <div class="row">
      <div class="col">
        <h5>{{ $t('book.detail.list.efile.heading') }}</h5>
        <book-efile-list :efiles="book_efiles" ></book-efile-list>
      </div>
    </div>
    <div class="row">
      <div class="col"><hr></div>
    </div>
    <div class="row">
      <div class="col">
        <b-button
          block
          variant="primary"
          :to="{ name: 'classified-books', params: { language: 'chinese' } }"
        >{{ $t('book.detail.button.view-more.label') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { LinkPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'

import BookInfo from '@/components/info/BookInfo'
import BookEfileList from '@/components/lists/BookEfileList'
import ApplicationList from '@/components/forms/dharma-application-form/ApplicationList'
import DharmaApplicationForm from '@/components/forms/dharma-application-form/DharmaApplicationForm'
import SizeCmConversionTableModal from '@/components/modals/SizeCmConversionTableModal'
import DharmaGrantSuspMsgModal from '@/components/modals/DharmaGrantSuspMsgModal'
import i18n from '@/plugins/i18n.js'
import BookApiService from '@/services/budaedu-api-services/book-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(IconsPlugin)
Vue.use(ImagePlugin)
Vue.use(LinkPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)

Vue.use(ApplicationList)
Vue.use(BookApiService)

export default {
  i18n,
  name: 'book',
  props: {
    id: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      book: null,
      book_cover: null,
      book_efiles: []
    }
  },
  methods: {
    addBookToApplicationList(book) {
      this.$dharmaApplicationList.addItem({
        code: book.code,
        name: book.chinese_name,
        quantity: book.quantity,
        advanced: book.advanced,
        apply_type: 'book'
      })

      this.$bvModal.show(`application-success-message-${this.$refs[`application_form`].uuid}`)

      // this.showDharmaGrantSuspensionMessage()
    },
    showDharmaGrantSuspensionMessage() {
      this.$bvModal.show('dharma-grant-susp-msg-modal')
    },
    showSizeCmConversionTableModal() {
      this.$bvModal.show('size-cm-conversion-table-modal')
    },
    async setBook() {
      const item = await this.$bookApiService.getById(this.id)
      this.book = item.data
      this.book_cover = await this.$bookApiService.getCover(this.book)
      this.book_efiles = await this.$bookApiService.getEfiles(this.book)
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`);
    await this.setBook()
  },
  components: {
    BookEfileList,
    BookInfo,
    DharmaApplicationForm,
    DharmaGrantSuspMsgModal,
    SizeCmConversionTableModal
  },
  metaInfo() {
    let title = ''
    if (this.book) {
      switch (this.$i18n.locale) {
        case 'tw':
          title = this.book.chinese_name
          break
        case 'en':
          title = this.book.english_name
          break
        default:
          title = this.$t('book.detail.title')
          break
      }
    }

    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>